import React, { useState } from 'react';
import { Input } from '../ui/input';
import { NumericKeypad } from './NumberKeypadCore';

// Riesporta il tastierino "core" per retro-compatibilità.
export { NumericKeypad };

/**
 * Campo importo con tastierino a comparsa (mostra suffisso €/% personalizzabile).
 * Il valore è gestito come stringa.
 */
export const AmountInput = ({ value, onValueChange, decimal = true, label, placeholder, className = '', 'data-testid': testId, suffix = '\u20ac', ...rest }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Input
        type="text"
        inputMode="decimal"
        readOnly
        value={value ?? ''}
        placeholder={placeholder}
        onClick={() => setOpen(true)}
        onFocus={(e) => { e.target.blur(); setOpen(true); }}
        className={`cursor-pointer ${className}`}
        data-testid={testId}
        {...rest}
      />
      <NumericKeypad
        open={open}
        onClose={() => setOpen(false)}
        initial={value}
        decimal={decimal}
        title={label}
        suffix={suffix}
        onConfirm={(v) => onValueChange(v)}
      />
    </>
  );
};
